import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import info from './modules/info'
import status from './modules/status'
import temp from './modules/activity'
import book from "./modules/book";
import control from './modules/control';
import route from './modules/route';
import viewer from "./modules/viewer";


Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    login,
    info,
    status,
    temp,
    book,
    control,
    route,
    viewer,
  },
  strict: debug
})
